<template>
  <!--footer class="copy">
             版权所有：网联科技  © 2015-2016 网联科技     粤ICP备08118912号-2
  </footer-->
</template>

<script>
export default {
  name: 'footerNav',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.copy{ text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/m/footer.vue